import { createI18n } from "vue-i18n";
import elementEnLocale from "element-plus/es/locale/lang/en";
import elementJaLocale from "element-plus/es/locale/lang/ja";
import elementZhLocale from "element-plus/es/locale/lang/zh-cn";
import en from "./locales/en";
import ja from "./locales/ja";
import zhCN from "./locales/zh-CN";

const messages = {
  en: {
    ...elementEnLocale,
    ...en,
  },
  ja: {
    ...elementJaLocale,
    ...ja,
  },
  zh: {
    ...elementZhLocale,
    ...zhCN,
  },
};

const getLanguage = async () => {
  return "zh";
};

export const getLocale = async () => {
  return "zh";
};

const i18n = createI18n({
  legacy: false,
  locale: await getLocale(), // 默认语言
  messages,
});

export default i18n;
